module.exports = __webpack_public_path__ + "static/img/recommend_product_max2.d2609cee.png";